import CloseFilled from '@mui/icons-material/Close';
import { LoadingButton } from '@mui/lab';
import {
  Backdrop,
  Card,
  CardActions,
  CardContent,
  Fade,
  Typography,
} from '@mui/material';
import Modal from '@mui/material/Modal';
import { Box } from '@mui/system';
import DocumentsIcon from 'components/icons/documents-icon';
import { useTranslation } from 'hooks/support/useTranslation';
import { useEffect, useState } from 'react';
import { ApiRoute } from 'utility/node/routes';

const DigitalDocumentsModal = ({
  show,
  partyId,
}: {
  show: boolean;
  partyId: number;
}) => {
  const { t } = useTranslation('common');
  const [posting, setPosting] = useState(false);
  const [open, setOpen] = useState(show);

  useEffect(() => {
    if (show) {
      setOpen(open);
    }
  }, [open]);

  const onClose = () => {
    setOpen(false);
  };

  const setModalAsShown = async () => {
    setPosting(true);
    await fetch(ApiRoute.MODAL_SHOWN, {
      method: 'POST',
      body: JSON.stringify({ partyId }),
    });
    setPosting(false);
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
    >
      <Fade in={open} mountOnEnter unmountOnExit>
        <Box
          sx={{
            width: '90%',
            height: 'auto',
            maxWidth: 655,
            position: 'absolute',
            maxHeight: 'calc(100vh - 32px)',
            overflowY: 'auto',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            '&:focus-visible': { outline: 'none' },
          }}
        >
          <Box position="relative">
            <Box
              position="absolute"
              right={16}
              top={12}
              onClick={onClose}
              sx={{ cursor: 'pointer', zIndex: 1 }}
            >
              <CloseFilled fontSize="medium" />
            </Box>
            <Card sx={{ p: 4 }}>
              <CardContent
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: 4,
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    color: 'primary.main',
                  }}
                >
                  <DocumentsIcon width={74} height={60} />
                </Box>
                <Typography variant="h5">
                  {t('digitalDocumentsModal.title')}
                </Typography>
                <Typography variant="body1" sx={{ whiteSpace: 'pre-line' }}>
                  {t('digitalDocumentsModal.description')}
                </Typography>
              </CardContent>
              <CardActions
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  p: 2,
                }}
              >
                <LoadingButton
                  disabled={posting}
                  size="large"
                  loading={posting}
                  type="submit"
                  variant="contained"
                  sx={{ width: '50%' }}
                  onClick={async () => {
                    await setModalAsShown();
                    onClose();
                  }}
                >
                  {t('digitalDocumentsModal.saveChanges')}
                </LoadingButton>
              </CardActions>
            </Card>
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
};

export default DigitalDocumentsModal;
